/**
 * The closed vocabularies the pathway speaks, and their French wording.
 *
 * Translated on this side rather than in the API because they are ENUM CODES, not prose: the backend
 * keeps saying `operee` whatever the interface language, so a locale that drifts cannot silently
 * change what a value means. Kept out of the component file so that one exports components only.
 */

import { msg } from "@lingui/macro";
import { useLingui } from "@lingui/macro";
import type { MessageDescriptor } from "@lingui/core";

/** ``CareEpisode.decision`` — how the episode was settled. */
export const DECISION_LABELS: Record<string, MessageDescriptor> = {
  operee: msg`Opérée`,
  conservatrice: msg`Conservatrice`,
  planifiee: msg`Planifiée`,
  non_documentee: msg`Non documentée`,
};

/** ``CareEpisode.outcome`` — how it ended, when a fact says so. */
export const OUTCOME_LABELS: Record<string, MessageDescriptor> = {
  recidive: msg`Récidive`,
  reprise: msg`Reprise`,
  perdu_de_vue: msg`Perdu de vue`,
};

/** ``CareEvent.kind`` — what kind of moment this is. */
export const KIND_LABELS: Record<string, MessageDescriptor> = {
  consultation: msg`Consultation`,
  imagerie: msg`Imagerie`,
  decision: msg`Décision`,
  traitement_conservateur: msg`Traitement conservateur`,
  intervention: msg`Intervention`,
  hospitalisation: msg`Hospitalisation`,
  suivi: msg`Suivi`,
};

/** How each outcome reads at a glance. `reprise` and `recidive` are deliberately NOT painted like a
 *  neutral state: they are the episodes a surgeon opens a record to find. */
export const OUTCOME_TONES: Record<string, string> = {
  recidive: "bg-blue-100 text-blue-900",
  reprise: "bg-blue-100 text-blue-900",
  perdu_de_vue: "bg-slate-100 text-slate-500",
};

export function useEventKindLabel(): (kind: string) => string {
  const { t } = useLingui();
  return (kind: string) => t(KIND_LABELS[kind] ?? msg`Moment`);
}
